export { default } from "./IconWrapper";
export type { IconWrapperProps } from "./IconWrapper";
